import React from "react";
import NoImage from "../NoImage/NoImage";

const ContactProfileImage = ({ photo, name, position }) => {
  return (
    <>
      {photo ? (
        <img className="persons_img" src={photo} alt={`${position} Image`} />
      ) : (
        <NoImage
          data={name?.split(" ")[0][0]}
          noImageClass={"no_image_connect_card"}
        />
      )}
    </>
  );
};

export default ContactProfileImage;
